import { SVGProps } from "react";

export function ExpressIcon({
  width = 24,
  height = 24,
  viewBox = "0 0 24 24",
  fill = "none",
  xmlns = "http://www.w3.org/2000/svg",
  ...props
}: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill={fill}
      xmlns={xmlns}
      {...props}
    >
      <g clipPath="url(#clip0_2448_13107)">
        <g clipPath="url(#clip1_2448_13107)">
          <path
            d="M1.65359 10.9396H11.5751V12.5932H1.65359V10.9396ZM0 6.80566H8.26795V8.45925H0V6.80566Z"
            fill="#ADB1B9"
          />
          <path
            d="M23.084 11.4409L20.6037 5.6533C20.54 5.50454 20.434 5.37775 20.299 5.28868C20.1639 5.19961 20.0056 5.15217 19.8438 5.15226H17.3635V3.49867C17.3635 3.27939 17.2763 3.06909 17.1213 2.91404C16.9662 2.75898 16.7559 2.67188 16.5367 2.67188H3.30793V4.32546H15.7099V14.7067C15.3331 14.9255 15.0034 15.2167 14.7398 15.5635C14.4761 15.9103 14.2837 16.3059 14.1737 16.7274H8.97809C8.77687 15.948 8.29826 15.2688 7.63207 14.817C6.96585 14.3652 6.15772 14.1719 5.35921 14.2734C4.56069 14.3748 3.82655 14.764 3.29444 15.3679C2.76232 15.9719 2.46875 16.7492 2.46875 17.5542C2.46875 18.3591 2.76232 19.1364 3.29444 19.7404C3.82655 20.3444 4.56069 20.7336 5.35921 20.835C6.15772 20.9364 6.96585 20.7431 7.63207 20.2914C8.29826 19.8396 8.77687 19.1604 8.97809 18.381H14.1737C14.3535 19.0906 14.7649 19.7199 15.3426 20.1695C15.9203 20.619 16.6314 20.8631 17.3635 20.8631C18.0955 20.8631 18.8066 20.619 19.3843 20.1695C19.962 19.7199 20.3734 19.0906 20.5532 18.381H22.3242C22.5435 18.381 22.7538 18.2939 22.9088 18.1388C23.0639 17.9838 23.151 17.7734 23.151 17.5542V11.7666C23.1511 11.6546 23.1283 11.5438 23.084 11.4409ZM5.7883 19.2078C5.46128 19.2078 5.14158 19.1108 4.86964 18.9291C4.59771 18.7474 4.38577 18.4891 4.2606 18.187C4.13543 17.8849 4.10269 17.5523 4.16652 17.2316C4.23031 16.9108 4.38779 16.6162 4.61907 16.3849C4.8503 16.1537 5.14494 15.9962 5.46571 15.9324C5.78648 15.8686 6.11897 15.9013 6.42111 16.0265C6.72326 16.1516 6.98155 16.3636 7.16323 16.6355C7.34491 16.9074 7.44193 17.2271 7.44193 17.5542C7.44145 17.9926 7.26712 18.4129 6.95711 18.723C6.64709 19.033 6.22673 19.2073 5.7883 19.2078ZM17.3635 6.80587H19.2981L21.0708 10.9398H17.3635V6.80587ZM17.3635 19.2078C17.0364 19.2078 16.7167 19.1108 16.4448 18.9291C16.1728 18.7474 15.9609 18.4891 15.8357 18.187C15.7106 17.8849 15.6778 17.5523 15.7416 17.2316C15.8054 16.9108 15.9629 16.6162 16.1942 16.3849C16.4255 16.1537 16.7201 15.9962 17.0409 15.9324C17.3616 15.8686 17.6941 15.9013 17.9963 16.0265C18.2984 16.1516 18.5567 16.3636 18.7383 16.6355C18.9201 16.9074 19.017 17.2271 19.017 17.5542C19.0166 17.9926 18.8422 18.4129 18.5322 18.723C18.2222 19.033 17.8019 19.2073 17.3635 19.2078ZM21.4974 16.7274H20.5532C20.3711 16.0192 19.9591 15.3914 19.3819 14.9426C18.8046 14.4937 18.0947 14.249 17.3635 14.247V12.5934H21.4974V16.7274Z"
            fill="#ADB1B9"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_2448_13107">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0 0.00292969)"
          />
        </clipPath>
        <clipPath id="clip1_2448_13107">
          <rect
            width="23.3333"
            height="18.1921"
            fill="white"
            transform="translate(0 2.67188)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
